module.exports = __webpack_public_path__ + "img/aboutTop.1a0e100f.png";